import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
    map,
    share,
    catchError,
    withLatestFrom,
    switchMap,
    repeat,
} from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { RequestSinacorNoteAction } from './report-sinacor.action';
import { HttpHeaders } from '@angular/common/http';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';


@Injectable()
export class RequestSinacorNoteEffects {
    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private httpService: HttpService,
        private settings: SettingsService,
    ) { }

    requestSinacorNote = createEffect(() =>
        this.actions$.pipe(
            ofType(RequestSinacorNoteAction.requestSinacorNote),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([action, auth]: [any, any]) => {
                const apiUrl = this.settings.getConfigurationKeyValue('backend');
                const body = action.payload;
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                return this.httpService.post<any>(`${apiUrl.api}/reports/sinacor-brokerage-note`, body, this._createHeaders(auth, isLogged))
                    .pipe(
                        map((reportResponse: any) => {
                            if (reportResponse) {
                                return {
                                    type: RequestSinacorNoteAction.requestSinacorNoteSuccess,
                                    payload: reportResponse
                                }
                            } else {
                                return { type: RequestSinacorNoteAction.requestSinacorNoteError, payload: {} }
                            }
                        })
                    );
            }),
            catchError((error) => of({ type: RequestSinacorNoteAction.requestSinacorNoteError, payload: error })),
            repeat(),
            share()
        )
    );

    private _createHeaders(userData: UsersState, logged: boolean = false) {
        if (!logged) {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'X-SessionID': `${userData.sessionID}`,
            });
        } else {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${userData.currentUser.token}`,
            });
        }
    }
}
